<div class="queries-container">
  <div class="queries-header">
  </div>
  
  <div class="queries-content">
    <div class="list-header">
      <h5>List of General Matters</h5>
      
      <div class="list-actions">
        <div class="search-box">
          <div class="input-group">
            <span class="input-group-text bg-transparent"><i class="bi bi-search"></i></span>
            <input 
              type="text" oninput="this.value = this.value.replace(/[^A-Za-z0-9 ]|^ /g,'')" 
              class="form-control" 
              placeholder="Search..." 
              [(ngModel)]="searchText">
          </div>
        </div>
      </div>
    </div>
    
    <div class="queries-table">
      <table class="table">
        <thead>
          <tr>
            <th class="thdata" scope="col">Name <i class="bi bi-arrow-down-up biarr" (click)="sortGeneralMatters('title')"></i></th>
            <th class="thdata" scope="col">Number <i class="bi bi-arrow-down-up biarr" (click)="sortGeneralMatters('caseNumber')"></i></th>
            <th class="thdata" scope="col">Type <i class="bi bi-arrow-down-up biarr" (click)="sortGeneralMatters('caseType')"></i></th>
            <th class="thdata" scope="col" style="width: 15%;">Created On <i class="bi bi-arrow-down-up biarr" (click)="sortGeneralMatters('created_on')"></i></th>
            <th class="thdata" scope="col" style="width: 15%;">Leads <i class="bi bi-arrow-down-up biarr" (click)="sortGeneralMatters('groups')"></i></th>
            <th class="thdata" scope="col">Status <i class="bi bi-arrow-down-up biarr" (click)="sortGeneralMatters('status')"></i></th>
            <th class="thdata" scope="col">Actions</th>  
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let general of getPaginatedMatters() | filter:searchText">
            <td>{{ general.title }}</td>
            <td>{{ general.caseNumber }}</td>
            <td>{{ general.caseType }}</td>
            <td>{{ general.created_on }}</td>
            <td style="white-space: pre-line;">{{ general.owner?.name }}</td>
            <td>{{ general.status }}</td>
            <td>
              <div class="dropdown actions-dropdown">
                <div class="dropdown">
                  <button class="btn btn-primary actionbtn dropdown" aria-expanded="false"
                    (click)="loadViewDetails(general,'external')">More Details</button>
                </div>
              </div>
            </td>
          </tr>
          <!-- <tr *ngIf="filteredQueries.length === 0">
            <td colspan="8" class="text-center noleads">No queries found</td>
          </tr> -->
        </tbody>
      </table>
    </div>

    <!-- Pagination added -->
    <div class="pagination-area" *ngIf="generalMatters.length > 0">
          <div class="pagination-info">
            {{ getPaginationRange() }}
          </div>
          
          <nav aria-label="Leads pagination">
            <ul class="pagination mb-0">
              <li class="page-item" [ngClass]="{'disabled': currentPage === 1}">
                <a class="page-link" href="javascript:void(0)" (click)="changePage(currentPage - 1)">
                  <i class="bi bi-chevron-left"></i> Previous
                </a>
              </li>
              
              <li *ngFor="let page of getPageNumbers()" class="page-item" [ngClass]="{'active': page === currentPage}">
                <a class="page-link" href="javascript:void(0)" (click)="changePage(page)">{{ page }}</a>
              </li>
              
              <li class="page-item" [ngClass]="{'disabled': currentPage === getTotalPages() || getTotalPages() === 0}">
                <a class="page-link" href="javascript:void(0)" (click)="changePage(currentPage + 1)">
                  Next <i class="bi bi-chevron-right"></i>
                </a>
              </li>
            </ul>
          </nav>
        </div>
        <!-- Pagination ends here-->

  </div>
</div>


<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-clip-rotate"
  [fullScreen]="true">
</ngx-spinner>